import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import { notEmpty } from "@orb-labs/types";
const DeviceSecurityContext = createContext(undefined);
export const useDeviceSecurity = () => {
    const context = useContext(DeviceSecurityContext);
    if (!notEmpty(context)) {
        throw new Error("useDeviceSecurity must be used within a DeviceSecurityProvider");
    }
    return context;
};
export const DeviceSecurityProvider = ({ runtime, children }) => (_jsx(DeviceSecurityContext.Provider, { value: runtime, children: children }));
